<template>
  <div class="layout">
    <!-- header 头部 -->
    <header-nav />
    <!-- 中间部分 -->
    <div class="section clearfix">
      <router-view />
    </div>
    <!-- footer 尾部 -->
    <div class="footer">
      Copyright © 2008～2021 {{ $t('message["1089"]') }}
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import HeaderNav from './Header'

export default {
  components: {
    HeaderNav
  },
  computed: {
    pid () {
      return this.$store.state.pid || this.$route.params.pid
    }
  },
  watch: {
    pid (pid) {
      this.init()
    }
  },
  created () {
    this.init()
  },
  methods: {
    ...mapActions('project', ['setPid', 'fetchDatas']),
    async init () {
      await this.setPid(this.pid)
      const chain = await this.fetchDatas()
      chain
        .params({
          id: this.pid
        })
        .fetch()
    }
  }
}
</script>
<style lang="scss">
@import '../../assets/css/pc.scss';
</style>
<style lang="scss" scoped>
.layout {
  overflow: hidden;
  background-color: #f5f6f7;
  .section {
    position: relative;
    // overflow: hidden;
    max-width: 1280px;
    margin: 16px auto 0;
    background-color: #fff;
    border: solid 1px $gray4;
    border-radius: 4px;

    .border {
      position: absolute;
      left: 159px;
      top: 0;
      z-index: 999;
      width: 1px;
      height: 100%;
      background-color: $gray4;
    }
    .right {
      float: left;
      width: calc(100% - 160px);
      min-height: calc(100vh - 116px);
      padding: 0 40px;
      // border-left: solid 1px $gray4;
    }
  }

  .footer {
    height: 44px;
    line-height: 44px;
    text-align: center;
    color: $gray3;
  }
}
@media screen and (max-width: 1200px) {
  .layout .section .right {
    .inner {
      width: 966px;
    }
    overflow-x: auto;
    overflow-y: hidden;
  }
  /* .layout .section {
    width: 1200px;
    overflow: auto;
  } */
}
</style>
